import { MessageBox } from 'element-ui'
import router from '@/router'
import api from '@/api'
import { setToken, getToken, removeToken } from '@/libs/util.token'
export default {
  namespaced: true,
  actions: {
    /**
     * @description 登录
     * @param {Object} context
     * @param {Object} payload username {String} 用户账号
     * @param {Object} payload password {String} 密码
     * @param {Object} payload route {Object} 登录成功后定向的路由对象 任何 vue-router 支持的格式
     */
    async login({ dispatch }, info = {}) {
      const res = await api.SYS_USER_LOGIN(info)
      const { status, body } = res
      if (status === 200) {
        // 设置 cookie 一定要存 uuid 和 token 两个 cookie
        // 整个系统依赖这两个数据进行校验和存储
        // uuid 是用户身份唯一标识 用户注册的时候确定 并且不可改变 不可重复
        // token 代表用户当前登录状态 建议在网络请求中携带 token
        // 如有必要 token 需要定时更新，默认保存一天
        // util.cookies.set('uuid', res.uuid)
        // util.cookies.set('token', body)
        setToken(body)
        // 设置 vuex 用户信息
        // await dispatch('admin/user/set', { name: '管理员' }, { root: true })
        // 用户登录后从持久化数据加载一系列的设置
        await dispatch('load')
      }

      return res
    },
    /**
     * @description 注销用户并返回登录页面
     * @param {Object} context
     * @param {Object} payload confirm {Boolean} 是否需要确认
     */
    logout({ dispatch }, options = {}) {
      if (window.__POWERED_BY_WUJIE__) {
        window.$wujie?.bus.$emit('logout', options)
        return
      }
      const { confirm = false } = options
      /**
       * @description 注销
       */
      async function logout() {
        // 删除cookie
        // util.cookies.remove('token')
        // util.cookies.remove('uuid')
        removeToken()
        // 清空已打开的标签
        await dispatch('admin/page/closeAll', {}, { root: true })
        // 清空 vuex 用户信息
        await dispatch('admin/user/set', {}, { root: true })
        // 清空菜单信息
        await dispatch('admin/menu/clearMenu', {}, { root: true })
        // 清空按钮权限信息
        await dispatch('admin/permission/clearBtnRole', {}, { root: true })

        if (router.app.$route.name !== 'login') {
          // 跳转路由
          router.push({ name: 'login' })
        }
      }
      // 判断是否需要确认
      if (confirm) {
        MessageBox.confirm('确定要注销当前用户吗', '注销用户', {
          type: 'warning'
        })
          .then(() => {
            api.SYS_USER_LOGOUT()
            logout()
          })
          .catch(() => {
            // Message({ message: '取消注销操作' })
          })
      } else {
        logout()
      }
    },
    /**
     * @description 用户登录后从持久化数据加载一系列的设置
     * @param {Object} context
     */
    async load({ dispatch }) {
      const token = getToken()
      if (token && token !== 'undefined') {
        // 持久化数据加载上次退出时的多页列表
        await dispatch('admin/page/openedLoad', null, { root: true })
        // 加载用户名
        await dispatch('admin/user/load', null, { root: true })
        // 持久化数据加载侧边栏配置
        await dispatch('admin/menu/asideLoad', null, { root: true })
      }
    }
  }
}
